import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ICONS } from 'src/assets/library';
import { signUpSchema } from 'src/config/yup';
import { useNavigate } from 'react-router-dom';
import { Container, Grid, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import CustomTextField from '../formFields/textField';
import LoaderButton from '../loaderButton/loaderButton';
import { SIGN_UP } from 'src/apiService/apiDeclaration';
import { OTP_VERIFICATION_MODE, showErrorTost, showSuccessTost } from 'src/constants';
import { t } from 'i18next';

const SignUpForm = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(signUpSchema),
  });

  const userSignUp = async (data) => {
    setLoading(true);
    const { confirmPassword, ...filteredData } = data;
    const formData = {
      ...filteredData,
      role: 'CUSTOMER',
      status: 'JOINED',
    };
    try {
      const signUp = await SIGN_UP(formData);
      showSuccessTost(signUp.message);
      navigate('/otp', { state: { email: data.email, verifcationMode: OTP_VERIFICATION_MODE.NEW_USER } });
    } catch (error) {
      showErrorTost(error.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(userSignUp)}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={'Email'}
              type="email"
              placeholder={t('common.placeholderEmail')}
              icon={ICONS.email}
              controller={{
                name: 'email',
                control: control,
                errors: errors.email,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('common.phone')}
              icon={ICONS.phone}
              type="text"
              placeholder={'+243811234567'}
              controller={{
                name: 'phoneNumber',
                control: control,
                errors: errors.phoneNumber,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('common.fName')}
              icon={ICONS.user}
              placeholder={t('common.placeholderFirstName')}
              type="name"
              controller={{
                name: 'firstName',
                control: control,
                errors: errors.firstName,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('common.lName')}
              icon={ICONS.user}
              placeholder={t('common.placeholderLastName')}
              type="name"
              controller={{
                name: 'lastName',
                control: control,
                errors: errors.lastName,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h8" mb={2}>
              {t('signupPage.note1')} <span style={{ fontWeight: 900 }}>{t('signupPage.note2')}</span>{' '}
              {t('signupPage.note3')}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('common.stAddress')}
              icon={ICONS.place}
              type="name"
              controller={{
                name: 'streetAddress',
                control: control,
                errors: errors.streetAddress,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('common.stNo')}
              icon={ICONS.place}
              type="name"
              controller={{
                name: 'streetNumber',
                control: control,
                errors: errors.streetNumber,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('common.municipality')}
              icon={ICONS.place}
              type="name"
              controller={{
                name: 'municipality',
                control: control,
                errors: errors.municipality,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('common.city')}
              icon={ICONS.city}
              type="name"
              controller={{
                name: 'city',
                control: control,
                errors: errors.city,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('common.password')}
              icon={ICONS.lock}
              type="password"
              isPassword
              controller={{
                name: 'password',
                control: control,
                errors: errors.password,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              icon={ICONS.lock}
              label={t('common.confirmPassword')}
              type="password"
              isPassword
              controller={{
                name: 'confirmPassword',
                control: control,
                errors: errors.confirmPassword,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('signupPage.reference')}
              icon={ICONS.reference}
              type="name"
              controller={{
                name: 'reference',
                control: control,
                errors: errors.reference,
              }}
            />
          </Grid>
          <Grid item xs={12} sx={{ mb: 3 }}>
            <LoaderButton
              loading={loading}
              disabled={!isValid}
              buttonText={t('signupPage.action.signup')}
              type="submit"
            />
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default SignUpForm;
